function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385963"
    },
    d: "M496,16c-8.836,0-16,7.164-16,16v16H32V32c0-8.836-7.164-16-16-16S0,23.164,0,32v32v192v224 c0,8.836,7.164,16,16,16s16-7.164,16-16V272h448v208c0,8.836,7.164,16,16,16s16-7.164,16-16V256V64V32 C512,23.164,504.836,16,496,16z M416,240v-80h-80v80h-80v-80h-80v80H96v-80H32V80h64v80h80V80h80v80h80V80h80v80h64v80H416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 80,
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 160,
    style: {
      fill: "#FFFFFF"
    },
    width: 64,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    style: {
      fill: "#FFFFFF"
    },
    width: 80,
    height: 80
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishPoint);
export default __webpack_public_path__ + "static/media/finish-point.8e701cf759edd5701579bb817c47e95e.svg";
export { ForwardRef as ReactComponent };